import React, { useState } from 'react';
import { FaqItem } from './FaqItem';
import { faqs } from '../../data/productContent';
import { siteConfig } from '../../data/siteConfig';
export function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);
  const midpoint = Math.ceil(faqs.length / 2);
  const columns = [faqs.slice(0, midpoint), faqs.slice(midpoint)];
  return <section id="faqs" aria-labelledby="faqs-title" className="scroll-mt-16 border-t border-line" data-id="element-171" data-mp="1v6gl2uwirvub">
      <div className="mx-auto max-w-page px-5 py-20 md:px-10 lg:py-24" data-id="element-172" data-mp="205jtmpbpkk71">
        <div className="mx-auto max-w-2xl text-center" data-id="element-173" data-mp="206uscaqar1ra">
          <h2 id="faqs-title" className="font-display text-4xl font-medium leading-tight text-ink md:text-[52px]" data-id="element-174" data-mp="1m6k5rjw0s9bx">
            Questions, Answered.
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-ink-muted" data-id="element-175" data-mp="3gjtgtg47s2wa">
            Something else on your mind? Call{' '}
            <a href={siteConfig.support.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-176" data-mp="3ljfsvm8b3d3i">
              {siteConfig.support.phone}
            </a>
            .
          </p>
        </div>
        <div data-faq-columns className="mt-10 grid gap-0 lg:mt-12 lg:grid-cols-2 lg:gap-12 xl:gap-16" data-id="element-177" data-mp="2jf5er3k3d4rg">
          {columns.map((column, index) => <div key={index} data-faq-column className="min-w-0 border-t border-ink [&+div]:border-t-0 lg:[&+div]:border-t" data-id="element-178" data-mp="2x7ldvt9vgin3" data-mpi={index}>
              {column.map(faq => <FaqItem key={faq.id} faq={faq} open={openId === faq.id} onToggle={() => setOpenId(id => id === faq.id ? null : faq.id)} data-id="element-179" data-mp="24huy7fsld8ov" />)}
            </div>)}
        </div>
      </div>
    </section>;
}